
import { createContext } from 'react';
import { IAuthContext } from '../../types/auth';


const AuthContext = createContext<IAuthContext>({
  isAuthError: false,
  authMessage: '',
  authLoading: false,
  isLoggedIn: false,
  isLoading: false,
  userInfo: null,
  login: (data:any) => {},
  logout: () => {},
  setUserInfo: (data:any) => {}
});

export default AuthContext;